












import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import StringUtils from '@/helpers/stringUtils';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class VisitsVisitorsDailyAvgCharts extends BaseComponent {
  @Prop()
  kpis: any[];

  @Prop()
  quantity: boolean;

  @Prop()
  configs: any;

  @Prop()
  keyValue: number;

  chartData: any[] = [];

  chartOptions = {
    backgroundColor: 'transparent',
    chartArea: { left: '200', top: '0', right: '20', bottom: '50' },
    legend: { position: 'bottom' },
    isStacked: false,
    colors: ['102D69'],
    fontSize: 12,
    hAxis: {
      minValue: 0
    },
    series: {
      1: {
        type: 'line',
        color: '#00AA00',
        lineDashStyle: [12, 6],
        lineWidth: 2,
        pointSize: 0
      }
    }
  };

  mounted() {
    this.load();
  }

  load() {
    this.chartData = [];

    if (this.quantity) {
      this.chartData.push(['Usuário', 'Quantidade de visitas (média diária)', { role: 'annotation' }, 'Meta']);
      this.kpis.forEach((i) => {
        this.chartData.push([
          `${StringUtils.abbreviate(i.nome, 25)}`,
          Math.ceil(i.quantidadeDiaMedia * 10) / 10,
          Math.ceil(i.quantidadeDiaMedia * 10) / 10,
          this.getGoalValue()
        ]);
      });
    } else {
      this.chartData.push(['Usuário', 'Tempo em visitas (média diária em horas)', { role: 'annotation' }, 'Meta']);
      this.kpis.forEach((i) => {
        this.chartData.push([
          `${StringUtils.abbreviate(i.nome, 25)}`,
          Math.ceil((i.tempoDiaMinutosMedia / 60) * 10) / 10,
          Math.ceil((i.tempoDiaMinutosMedia / 60) * 10) / 10,
          this.getGoalValue()
        ]);
      });
    }
  }

  @Watch('kpis', { immediate: true })
  @Watch('configs', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }

  getGoalValue() {
    if (!this.configs) {
      return null;
    }
    if (this.quantity) {
      return this.configs.qtdeMetaDiaria;
    }
    return this.configs.tempoMetaDiariaHoras;
  }
}
